import bdjs from "@bd-core/bdjs";
import CONFIG from "@bd-core/config";
import $ from "jquery";

export const LoginPage = () => {
    const INTRO_WATCHED_SESSION_KEY = "fci_all_stars_intro_watched_session";

    const elms = {
        loginPage: "#login-page",
        app: ".app",
        passwordToggle: ".js-password-toggle",
        passwordInput: ".js-password-input",
        loginFormButton: ".login__form-button",
    };

    const isLoginPage = $(elms.loginPage).length > 0;
    if (!isLoginPage) return false;

    const submitLogin = async () => {
        bdjs.showLoading();

        const [response] = await bdjs.goAsync(
            bdjs.makeRequest(
                window.location.origin + "/wp-admin/admin-ajax.php",
                {
                    action: "login",
                    password: $(elms.passwordInput).val(),
                    nonce: CONFIG.nonce,
                },
            ),
        );

        const result = response.data;

        if (result.success) {
            try {
                sessionStorage.removeItem(INTRO_WATCHED_SESSION_KEY);
            } catch (e) {
                // ignore storage errors (private mode, etc.)
            }
            window.location.href = result.data.redirect_url;
        } else {
            alert(result.data);
        }

        bdjs.hideLoading();
    };

    $(elms.loginFormButton).on("click", submitLogin);
    $(elms.passwordInput).on("keydown", function(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            e.preventDefault();
            if (!$(elms.loginFormButton).prop("disabled")) {
                submitLogin();
            }
        }
    });

    $(elms.passwordToggle).on("click", (e) => {
        e.preventDefault();
        $(e.currentTarget).toggleClass("is-active");
        $(elms.passwordInput).attr(
            "type",
            $(e.currentTarget).hasClass("is-active") ? "text" : "password",
        );
    });

    $(elms.passwordInput).on("input", (e) => {
        const password = $(e.currentTarget).val();
        const hasValue = String(password).trim().length > 0;
        if (hasValue) {
            $(elms.loginFormButton).prop("disabled", false);
        } else {
            $(elms.loginFormButton).prop("disabled", true);
        }
    });
};
